import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1620_166)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.25391 3.74609L9.02734 7.51953L12.7734 3.74609C13.1016 3.41797 13.6758 3.41797 14.0039 3.74609C14.3594 4.10156 14.3594 4.64844 14.0039 5.00391L10.2578 8.75L14.0039 12.4961C14.3594 12.8516 14.3594 13.3984 14.0039 13.7539C13.6758 14.082 13.1016 14.082 12.7734 13.7539L9.02734 9.98047L5.25391 13.7539C4.92578 14.082 4.35156 14.082 4.02344 13.7539C3.66797 13.3984 3.66797 12.8516 4.02344 12.4961L7.76953 8.75L4.02344 5.00391C3.66797 4.64844 3.66797 4.10156 4.02344 3.74609C4.35156 3.41797 4.92578 3.41797 5.25391 3.74609Z",
			fill: "#C5C5C5"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1620_166",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgIconClose;
